import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/siteInfo';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-mental-health-line text-lg"></i>
                </span>
                <span className="text-lg font-heading font-semibold text-background-50">
                  前列腺健康科普
                </span>
              </div>
              <p className="text-sm text-secondary-200 leading-relaxed">
                {siteInfo.tagline}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">文章分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-secondary-200 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <i className={`${cat.icon} mr-1.5 text-xs`}></i>
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-secondary-200 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-secondary-200 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/safety" className="text-sm text-secondary-200 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                    安全须知
                  </Link>
                </li>
                <li>
                  <Link to="/category/faq" className="text-sm text-secondary-200 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                    常见问题
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">免责声明</h4>
              <p className="text-sm text-secondary-200 leading-relaxed">
                本站所有内容仅供健康知识科普参考，不构成医疗建议。如有健康问题，请及时咨询专业医生。本站内容经过专业医学审核，但不保证完全无误。
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-700 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-300">
            &copy; {new Date().getFullYear()} 前列腺健康知识科普. 版权所有.
          </p>
          <p className="text-xs text-secondary-400">
            本站内容仅供成年人阅读，仅作健康科普参考
          </p>
        </div>
      </div>
    </footer>
  );
}